<template>
  <div class="filter-form">
    <ElForm label-width="60" inline class="elementui-common-form-styles" v-highlight>
      <ElFormItem label="层级">
        <ElSelect v-model="bizType" @change="sendEvent" style="width: 180px">
          <ElOption :value="-1" label="不限"></ElOption>
          <ElOption :value="1" label="计划组"></ElOption>
          <ElOption :value="2" label="计划"></ElOption>
          <ElOption :value="3" label="创意"></ElOption>
          <ElOption :value="4" label="账号"></ElOption>
          <ElOption :value="5" label="素材"></ElOption>
        </ElSelect>
      </ElFormItem>
      <ElFormItem label="操作类型">
        <ElSelect v-model="type" @change="sendEvent" style="width: 180px">
          <ElOption :value="-1" label="不限"></ElOption>
          <ElOption :value="2" label="更改名称"></ElOption>
          <ElOption :value="3" label="更改预算"></ElOption>
          <ElOption :value="4" label="更改第一阶段出价"></ElOption>
          <ElOption :value="5" label="更改第二阶段出价"></ElOption>
          <ElOption :value="6" label="启动状态"></ElOption>
          <ElOption :value="7" label="暂停状态"></ElOption>
          <ElOption :value="8" label="消息提醒"></ElOption>
          <ElOption :value="9" label="删除计划"></ElOption>
          <ElOption :value="10" label="复制计划"></ElOption>
        </ElSelect>
      </ElFormItem>
      <ElFormItem label="执行人">
        <ThrottleSelector
          v-model="agentId"
          @change="sendEvent"
          :list="SYS_USERS"
          style="width: 140px"
          placeholder="全部"
          filterable
          clearable
        />
      </ElFormItem>
      <ElFormItem label="执行状态">
        <ElSelect v-model="opStatus" @change="sendEvent" style="width: 120px">
          <ElOption :value="-1" label="不限"></ElOption>
          <ElOption :value="0" label="成功"></ElOption>
          <ElOption :value="1" label="失败"></ElOption>
        </ElSelect>
      </ElFormItem>
      <ElFormItem label="媒体">
        <ElSelect v-model="media" style="width: 100px" @change="sendEvent">
          <ElOption :value="-1" label="不限"></ElOption>
          <ElOption :value="10" label="巨量引擎"></ElOption>
          <ElOption :value="16" label="腾讯"></ElOption>
          <ElOption :value="32" label="磁力引擎"></ElOption>
          <ElOption :value="45" label="百度信息流"></ElOption>
          <ElOption :value="6" label="超级汇川"></ElOption>
        </ElSelect>
      </ElFormItem>
      <ElFormItem label="任务类型">
        <ElSelect v-model="ruleType" style="width: 120px" @change="sendEvent">
          <ElOption :value="-1" label="不限"></ElOption>
          <ElOption :value="1" label="自动化规则"></ElOption>
          <ElOption :value="3" label="一键关停"></ElOption>
          <ElOption :value="0" label="手动操作"></ElOption>
          <ElOption :value="4" label="人员消耗管控"></ElOption>
          <ElOption :value="2" label="新游管控"></ElOption>
        </ElSelect>
      </ElFormItem>
      <ElFormItem label="计划账号">
        <ThrottleSelector
          v-model="accountId"
          @change="sendEvent"
          :list="MEDIA_ACCOUNTS"
          style="width: 180px"
          placeholder="全部"
          filterable
          clearable
        />
      </ElFormItem>
      <ElFormItem label="计划新建人">
        <ThrottleSelector
          v-model="createOpId"
          @change="sendEvent"
          :list="SYS_USERS"
          style="width: 180px"
          placeholder="全部"
          filterable
          clearable
        />
      </ElFormItem>
      <ElFormItem>
        <DateRangePicker v-model="datetime" @change="sendEvent" style="width: 220px"></DateRangePicker>
      </ElFormItem>
      <ElFormItem>
        <ElInput v-model.trim="keyword" :placeholder="placeholder" style="width: 220px" @keyup.enter.native="search">
          <i slot="append" @click="search" class="el-icon-search"></i>
        </ElInput>
      </ElFormItem>
    </ElForm>
  </div>
</template>
<script>
import moment from 'moment'
import ThrottleSelector from '@/components/throttle-select/index.vue'
import DateRangePicker from '@/components/date-range-picker'
import { SYS_USERS, MEDIA_ACCOUNTS, initPageData } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([SYS_USERS, MEDIA_ACCOUNTS])

export default {
  name: 'monitorLogFilter',
  components: { DateRangePicker, ThrottleSelector },
  props: {
    placeholder: {
      type: String
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS
  },
  methods: {
    buildParams() {
      const [queryBeginTime, queryEndTime] = this.datetime || []
      const params = {
        queryBeginTime,
        queryEndTime,
        bizType: this.bizType === -1 ? undefined : this.bizType,
        opType: this.type === -1 ? undefined : this.type,
        opStatus: this.opStatus === -1 ? undefined : this.opStatus,
        adAccountId: this.accountId === '' ? undefined : this.accountId,
        mediaId: this.media === -1 ? undefined : this.media,
        opId: this.agentId === '' ? undefined : this.agentId,
        launchOpId: this.createOpId === '' ? undefined : this.createOpId,
        ruleType: this.ruleType === -1 ? undefined : this.ruleType
      }

      return params
    },
    sendEvent() {
      const params = this.buildParams()
      this.$emit('on-change', params)
    },
    search() {
      let params = this.buildParams()
      params = Object.assign(params, { keyWord: this.keyword === '' ? undefined : this.keyword })
      this.$emit('on-search', params)
    }
  },
  data() {
    const start = moment().format('YYYY-MM-01')
    const now = moment().format('YYYY-MM-DD')
    return {
      datetime: [start, now],
      createOpId: '',
      keyword: '',
      media: -1,
      type: -1,
      bizType: -1,
      opStatus: -1,
      ruleType: -1,
      agentId: '',
      agentData: [],
      accountId: '',
      accountData: [] // 账号
    }
  },
  created() {
    this.sendEvent()
  }
}
</script>
<style lang="scss" scoped>
.filter-form {
  padding-top: 10px;
}
</style>
